<template>
  <aside class="mp-sidebar">
    <div class="mp-sidebar__header">
      <span class="mp-sidebar__logo">Angel IA</span>
      <button class="mp-btn-icon" title="Nouveau chat" @click="$emit('new')">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="12" y1="5" x2="12" y2="19"/>
          <line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
      </button>
    </div>

    <div class="mp-sidebar__list">
      <div v-if="pinnedChats.length" class="mp-sidebar__section-label">Épinglés</div>
      <MpChatItem
        v-for="chat in pinnedChats"
        :key="chat.id"
        :chat="chat"
        :active="chat.id === activeChatId"
        @select="$emit('select', chat.id)"
        @delete="$emit('delete', chat.id)"
        @pin="$emit('pin', chat.id)"
        @rename="$emit('rename', $event)"
      />
      <div v-if="unpinnedChats.length" class="mp-sidebar__section-label">
        {{ pinnedChats.length ? 'Récents' : '' }}
      </div>
      <MpChatItem
        v-for="chat in unpinnedChats"
        :key="chat.id"
        :chat="chat"
        :active="chat.id === activeChatId"
        @select="$emit('select', chat.id)"
        @delete="$emit('delete', chat.id)"
        @pin="$emit('pin', chat.id)"
        @rename="$emit('rename', $event)"
      />
      <div v-if="!chats.length" class="mp-sidebar__empty">
        <p>Aucun chat</p>
      </div>
    </div>
  </aside>
</template>

<script>
import MpChatItem from './MpChatItem.vue';

export default {
  name: 'MpSidebar',
  components: { MpChatItem },
  props: {
    chats: { type: Array, default: () => [] },
    activeChatId: { type: Number, default: null },
  },
  computed: {
    pinnedChats() {
      return this.chats.filter(function(c) { return c.is_pinned; });
    },
    unpinnedChats() {
      return this.chats.filter(function(c) { return !c.is_pinned; });
    },
  },
};
</script>

<style scoped>
.mp-sidebar {
  width: 260px;
  min-width: 260px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  border-right: 1px solid #e8e8e6;
}
.mp-sidebar__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 14px;
  border-bottom: 1px solid #e8e8e6;
  flex-shrink: 0;
}
.mp-sidebar__logo {
  font-size: 14px;
  font-weight: 600;
  color: #1c1c1e;
  letter-spacing: 0.3px;
}
.mp-btn-icon {
  background: none;
  border: none;
  color: #8e8e93;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  transition: color 0.15s, background 0.15s;
}
.mp-btn-icon:hover {
  color: #1c1c1e;
  background: #f0f0ee;
}
.mp-sidebar__list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 6px;
}
.mp-sidebar__list::-webkit-scrollbar { width: 4px; }
.mp-sidebar__list::-webkit-scrollbar-track { background: transparent; }
.mp-sidebar__list::-webkit-scrollbar-thumb { background: #d1d1d6; border-radius: 2px; }
.mp-sidebar__section-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #aeaeb2;
  padding: 8px 8px 4px;
}
.mp-sidebar__empty {
  text-align: center;
  padding: 32px 16px;
  color: #aeaeb2;
  font-size: 13px;
}
</style>
